import gql from 'graphql-tag';

export const GET_FINANCE_ANALYTICS = gql`
  query GetFinancialAnalytic($period: PeriodFilterInput) {
    getFinancialAnalytic(period: $period) {
      financialAnalytic {
        totalGrantsAmount
        totalTransactionAmount
        subscriptionRevenues {
          daily
          monthly
          quarterly
          weekly
          yearly
        }
        conversionMetrics {
          conversionRate
          convertedToPayingCustomers
          totalFreeTrials
        }
        premiumMetrics {
          currentlyPremium
          totalExPremium
        }
        resubscriptionMetrics {
          resubscriptionRate
          totalPremiumUsers
          usersWhoResubscribed
          distributionChart {
            resubscriptionCount
            studentCount
          }
        }
        revenueTrendChart {
          period
          revenue
        }
        salesDistribution {
          daily
          monthly
          quarterly
          weekly
        }
      }
      userDistribution {
        freeCandidates
        freeMode
        freeTrialMode
        premiumMode
      }
    }
  }
`;
